// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
.category-filter-container {
  display: inline-block;
  position: relative;
  color: #9dbcda;
}
.category-filter-container ::ng-deep dua-filter-button {
  margin-right: 0;
  margin-bottom: 0;
}

.category-picker-panel {
  width: 280px;
  max-width: 280px;
  box-sizing: border-box;
}

.checkbox-list {
  display: flex;
  flex-direction: column;
}

.checkbox-container {
  display: flex;
  align-items: center;
  margin: 8px 0;
}

.select-all-row {
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #3f5061;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
